<template>
	<div>
        <div class="row">
            <div class="col-md-12">
                <el-form  class="mt-0" label-position="top" label-width="100px">
                    <div class="row">
                        <div class="col-md-2">	
                            <el-form-item label="Bulan:">
                                <el-select v-model="month" filterable placeholder="Select Month" size="medium" style="width:100%;">
                                    <el-option v-for="item3 in options.months" :key="item3.value" :label="item3.name" :value="item3.value">
                                    </el-option>
                                </el-select>
                            </el-form-item>
                        </div>
                        <div class="col-md-2">	
                            <el-form-item label="Tahun:" style="min-width:85px;">
                                <!-- clearable -->
                                <el-select v-model="year" filterable placeholder="Select Year" size="medium" style="width:100%;">
                                    <el-option v-for="item3 in options.years" :key="item3.value" :label="item3.name" :value="item3.value">
                                    </el-option>
                                </el-select>
                            </el-form-item>
                        </div>
                        <div class="col-md-2">	
                            <el-form-item label=" ">
                                <el-button type="primary" size="medium" :loading="loading.table" @click="applyFilter" style="width:100%;">Apply</el-button>
                            </el-form-item>
                        </div>
                        <div class="col-md-6 text-right" v-if="lastUpdate != ''">
                            <el-form-item label=" ">
                                {{ this.lastUpdate }}
                            </el-form-item>
                        </div>
                    </div>
                </el-form>

                <div class="row">
                    <div class="col-md-12">
                        <table class="app-table">
                            <tr>
                                <th rowspan="2">Jenis Produk</th>
                                <th rowspan="2">YTD {{ this.options.months.find(d=> d.value==this.month).name }} {{ this.year - 1}}</th>
                                <th colspan="3">{{ this.year }} (Volume KL/KLSP)</th>
                                <th colspan="3">% Real {{ this.year - 1}} Terhadap</th>
                            </tr>
                            <tr>
                                <th>RKAP</th>
                                <th>RKAP YTD</th>
                                <th class="top-red-border red-border">REAL YTD {{ this.options.months.find(d=> d.value==this.month).name }}</th>
                                <th class="top-yellow-border yellow-border">RKAP YTD</th>
                                <th>RKAP {{ this.year }}</th>
                                <th>YTD {{ this.options.months.find(d=> d.value==this.month).name }} {{ this.year - 1}}</th>
                            </tr>
                            <tr>
                                <td></td>
                                <td class="text-center">a</td>
                                <td class="text-center">b</td>
                                <td class="text-center">c</td>
                                <td class="text-center red-border">d</td>
                                <td class="text-center yellow-border">e=d:c</td>
                                <td class="text-center">f=d:b</td>
                                <td class="text-center">g=d:a</td>
                            </tr>
                            <tr>
                                <td colspan="8" style="padding:0px"></td>
                            </tr>
                            <tr>
                                <td class="sub-header-cell">{{ reportData.data.gasoil_total.ProductName }}</td>
                                <td class="text-right sub-header-cell">{{ formatNum(reportData.data.gasoil_total.ytd_month) }}</td>
                                <td class="text-right sub-header-cell">{{ formatNum(reportData.data.gasoil_total.volume_rkap) }}</td>
                                <td class="text-right sub-header-cell">{{ formatNum(reportData.data.gasoil_total.volume_rkap_ytd) }}</td>
                                <td class="text-right sub-header-cell red-border">{{ formatNum(reportData.data.gasoil_total.volume_real_ytd_month) }}</td>
                                <td class="text-right sub-header-cell yellow-border">{{ formatNum(divideNum(reportData.data.gasoil_total.volume_real_ytd_month / reportData.data.gasoil_total.volume_rkap_ytd) * 100 ) }}%</td>
                                <td class="text-right sub-header-cell">{{ formatNum(divideNum(reportData.data.gasoil_total.volume_real_ytd_month / reportData.data.gasoil_total.volume_rkap) * 100) }}%</td>
                                <td class="text-right sub-header-cell">{{ formatNum(divideNum(reportData.data.gasoil_total.volume_real_ytd_month / reportData.data.gasoil_total.ytd_month) * 100 ) }}%</td>
                            </tr>
                            <tr v-for="item4 in reportData.data.gasoil" :key="item4.ProductCode">
                                <td>{{ item4.ProductName }}</td>
                                <td class="text-right">{{ formatNum(item4.ytd_month) }}</td>
                                <td class="text-right">{{ formatNum(item4.volume_rkap) }}</td>
                                <td class="text-right">{{ formatNum(item4.volume_rkap_ytd) }}</td>
                                <td class="text-right red-border">{{ formatNum(item4.volume_real_ytd_month) }}</td>
                                <td class="text-right yellow-border">{{ formatNum(divideNum(item4.volume_real_ytd_month/item4.volume_rkap_ytd) * 100) }}%</td>
                                <td class="text-right">{{ formatNum(divideNum(item4.volume_real_ytd_month/item4.volume_rkap) * 100) }}%</td>
                                <td class="text-right">{{ formatNum(divideNum(item4.volume_real_ytd_month/item4.ytd_month) * 100) }}%</td>
                            </tr>
                            <tr>
                                <td class="sub-header-cell">{{ reportData.data.gasoline_total.ProductName }}</td>
                                <td class="text-right sub-header-cell">{{ formatNum(reportData.data.gasoline_total.ytd_month) }}</td>
                                <td class="text-right sub-header-cell">{{ formatNum(reportData.data.gasoline_total.volume_rkap) }}</td>
                                <td class="text-right sub-header-cell">{{ formatNum(reportData.data.gasoline_total.volume_rkap_ytd) }}</td>
                                <td class="text-right sub-header-cell red-border">{{ formatNum(reportData.data.gasoline_total.volume_real_ytd_month) }}</td>
                                <td class="text-right sub-header-cell yellow-border">{{ formatNum(divideNum(reportData.data.gasoline_total.volume_real_ytd_month/reportData.data.gasoline_total.volume_rkap_ytd) * 100) }}%</td>
                                <td class="text-right sub-header-cell">{{ formatNum(divideNum(reportData.data.gasoline_total.volume_real_ytd_month/reportData.data.gasoline_total.volume_rkap) * 100) }}%</td>
                                <td class="text-right sub-header-cell">{{ formatNum(divideNum(reportData.data.gasoline_total.volume_real_ytd_month/reportData.data.gasoline_total.ytd_month) * 100) }}%</td>
                            </tr>
                            <tr v-for="item4 in reportData.data.gasoline" :key="item4.ProductCode">
                                <td>{{ item4.ProductName }}</td>
                                <td class="text-right">{{ formatNum(item4.ytd_month) }}</td>
                                <td class="text-right">{{ formatNum(item4.volume_rkap) }}</td>
                                <td class="text-right">{{ formatNum(item4.volume_rkap_ytd) }}</td>
                                <td class="text-right red-border">{{ formatNum(item4.volume_real_ytd_month) }}</td>
                                <td class="text-right yellow-border">{{ formatNum(divideNum(item4.volume_real_ytd_month/item4.volume_rkap_ytd) * 100) }}%</td>
                                <td class="text-right">{{ formatNum(divideNum(item4.volume_real_ytd_month/item4.volume_rkap) * 100) }}%</td>
                                <td class="text-right">{{ formatNum(divideNum(item4.volume_real_ytd_month/item4.ytd_month) * 100) }}%</td>
                            </tr>
                            <tr>
                                <td class="sub-header-cell">{{ reportData.data.total.ProductName }}</td>
                                <td class="text-right sub-header-cell">{{ formatNum(reportData.data.total.ytd_month) }}</td>
                                <td class="text-right sub-header-cell">{{ formatNum(reportData.data.total.volume_rkap) }}</td>
                                <td class="text-right sub-header-cell">{{ formatNum(reportData.data.total.volume_rkap_ytd) }}</td>
                                <td class="text-right sub-header-cell red-border">{{ formatNum(reportData.data.total.volume_real_ytd_month) }}</td>
                                <td class="text-right sub-header-cell yellow-border">{{ formatNum(divideNum(reportData.data.total.volume_real_ytd_month/reportData.data.total.volume_rkap_ytd) * 100) }}%</td>
                                <td class="text-right sub-header-cell">{{ formatNum(divideNum(reportData.data.total.volume_real_ytd_month/reportData.data.total.volume_rkap) * 100) }}%</td>
                                <td class="text-right sub-header-cell">{{ formatNum(divideNum(reportData.data.total.volume_real_ytd_month/reportData.data.total.ytd_month) * 100) }}%</td>
                            </tr>
                            <tr v-for="item4 in reportData.data.gas" :key="item4.ProductCode">
                                <td>{{ item4.ProductName }}</td>
                                <td class="text-right">{{ formatNum(item4.ytd_month) }}</td>
                                <td class="text-right">{{ formatNum(item4.volume_rkap) }}</td>
                                <td class="text-right">{{ formatNum(item4.volume_rkap_ytd) }}</td>
                                <td class="text-right red-border">{{ formatNum(item4.volume_real_ytd_month) }}</td>
                                <td class="text-right yellow-border">{{ formatNum(divideNum(item4.volume_real_ytd_month/item4.volume_rkap_ytd) * 100) }}%</td>
                                <td class="text-right">{{ formatNum(divideNum(item4.volume_real_ytd_month/item4.volume_rkap) * 100) }}%</td>
                                <td class="text-right">{{ formatNum(divideNum(item4.volume_real_ytd_month/item4.ytd_month) * 100) }}%</td>
                            </tr>
                            <tr>
                                <td class="sub-header-cell">{{ reportData.data.grand_total.ProductName }}</td>
                                <td class="text-right sub-header-cell">{{ formatNum(reportData.data.grand_total.ytd_month) }}</td>
                                <td class="text-right sub-header-cell">{{ formatNum(reportData.data.grand_total.volume_rkap) }}</td>
                                <td class="text-right sub-header-cell">{{ formatNum(reportData.data.grand_total.volume_rkap_ytd) }}</td>
                                <td class="text-right sub-header-cell red-border bottom-red-border">{{ formatNum(reportData.data.grand_total.volume_real_ytd_month) }}</td>
                                <td class="text-right sub-header-cell yellow-border bottom-yellow-border">{{ formatNum(divideNum(reportData.data.grand_total.volume_real_ytd_month/reportData.data.grand_total.volume_rkap_ytd) * 100) }}%</td>
                                <td class="text-right sub-header-cell">{{ formatNum(divideNum(reportData.data.grand_total.volume_real_ytd_month/reportData.data.grand_total.volume_rkap) * 100) }}%</td>
                                <td class="text-right sub-header-cell">{{ formatNum(divideNum(reportData.data.grand_total.volume_real_ytd_month/reportData.data.grand_total.ytd_month) * 100) }}%</td>
                            </tr>
                        </table>
                        <div class="mt-2 text-right">
                            <i>*Source data by SAP & Jasa kompresi</i>&nbsp;
                        </div>
                        <Loader v-if="loading.table"/>
                    </div>
                </div>
<!--
                <el-table
                    :data="tableData"
                    stripe
                    v-loading="loading.table"
                    :border="true"
                    :show-header="true"
                    style="width: 100%; font-size:14px;"
                    :header-cell-style="{paddingTop: '8px', paddingBottom: '2px', background: '#F5F7FA'}"
                    :header-row-style="{padding:'0px'}"
                    :cell-style="{padding: '8px 0px', borderBottom: '1px solid #EBEEF5', borderRight: '0px solid #EBEEF5'}"   
                    class="no-border mt-2"
                    width="100%"
                    id="table">

                    <el-table-column
                        fixed
                        prop="product"
                        label="Jenis Produk"
                        header-align="center">
                    </el-table-column>

                    <el-table-column
                        fixed
                        prop="month_ytd"
                        label="YTD SEPTEMBER 2022"
                        header-align="center"
                        width="170"
                        align="right">
                    </el-table-column>

                    <el-table-column
                        label="2023 (Volume KL/KLSP)"
                        header-align="center">
                        <el-table-column
                            prop="volume_rkap"
                            label="RKAP"
                            width="120"
                            align="right"
                            header-align="center">
                        </el-table-column>
                        <el-table-column
                            prop="volume_rkap_ytd"
                            label="RKAP YTD"
                            width="120"
                            align="right"
                            header-align="center">
                        </el-table-column>
                        <el-table-column
                            prop="volume_real_ytd_month"
                            label="REAL YTD MEI"
                            width="170"
                            align="right"
                            header-align="center">
                        </el-table-column>
                    </el-table-column>

                    <el-table-column
                        label="% Real 2022 Terhadap"
                        header-align="center">
                        <el-table-column
                            prop="real_rkap_ytd"
                            label="RKAP YTD"
                            width="100"
                            align="right"
                            header-align="center">
                        </el-table-column>
                        <el-table-column
                            prop="real_rkap_month"
                            label="RKAP 2023"
                            width="100"
                            align="right"
                            header-align="center">
                        </el-table-column>
                        <el-table-column
                            prop="real_ytd_month"
                            label="YTD MEI 2022"
                            width="170"
                            align="right"
                            header-align="center">
                        </el-table-column>
                    </el-table-column>
                </el-table>
            -->
            </div>
        </div>
    </div>
</template>

<script>
import KinerjaKeuangan from '@/components/page/KinerjaKeuangan.js'
import {Config,Penanggalan, AxiosWithJar } from '@/utility.js'
import Loader from '@/components/loader/Loader2.vue'

export default
{
	extends: KinerjaKeuangan,
	components: { 
        Loader,
		//ReportParamSelect,
	},

	data() {
		return {
            month: ""+(Penanggalan().bulan-1),
            year: ""+Penanggalan().tahun,

            loading: {
                table: false,
            },

            reportData: {
                data: {
                    gasoil_total: {
                        ProductCode: "",
                        ProductName: "GASOIL (KL)",
                        ytd_month: 0,
                        volume_rkap: 0,
                        volume_rkap_ytd: 0,
                        volume_real_ytd_month: 0
                    },
                    gasoline_total: {
                        ProductCode: "",
                        ProductName: "GASOLINE (KL)",
                        ytd_month: 0,
                        volume_rkap: 0,
                        volume_rkap_ytd: 0,
                        volume_real_ytd_month: 0
                    },
                    bbg_total: {
                        ProductCode: "",
                        ProductName: "BBG (KL)",
                        ytd_month: 0,
                        volume_rkap: 0,
                        volume_rkap_ytd: 0,
                        volume_real_ytd_month: 0
                    },
                    total: {
                        ProductCode: "",
                        ProductName: "TOTAL",
                        ytd_month: 0,
                        volume_rkap: 0,
                        volume_rkap_ytd: 0,
                        volume_real_ytd_month: 0
                    },
                    grand_total: {
                        ProductCode: "",
                        ProductName: "GRAND TOTAL",
                        ytd_month: 0,
                        volume_rkap: 0,
                        volume_rkap_ytd: 0,
                        volume_real_ytd_month: 0
                    },
                },
            },

            tableData: [
                {
                    product: 'Gasoil (KL)',
                    month_ytd: '275.897',
                    volume_rkap: '657.823',
                    volume_rkap_ytd: '266.196',
                    volume_real_ytd_month: '312.565',
                    real_rkap_ytd: '117%',
                    real_rkap_month: '48%',
                    real_ytd_month: '113%',
                }, 
                {
                    product: 'Solar/Bio Solar',
                    month_ytd: '233.471',
                    volume_rkap: '540.149',
                    volume_rkap_ytd: '266.196',
                    volume_real_ytd_month: '312.565',
                    real_rkap_ytd: '117%',
                    real_rkap_month: '48%',
                    real_ytd_month: '113%',
                }, 
                {
                    product: 'Pertamina Dex',
                    month_ytd: '275.897',
                    volume_rkap: '657.823',
                    volume_rkap_ytd: '266.196',
                    volume_real_ytd_month: '312.565',
                    real_rkap_ytd: '117%',
                    real_rkap_month: '48%',
                    real_ytd_month: '113%',
                }, 
                {
                    product: 'Dexlite',
                    month_ytd: '275.897',
                    volume_rkap: '657.823',
                    volume_rkap_ytd: '266.196',
                    volume_real_ytd_month: '312.565',
                    real_rkap_ytd: '117%',
                    real_rkap_month: '48%',
                    real_ytd_month: '113%',
                },
                {
                    product: 'Gasoline (KL)',
                    month_ytd: '275.897',
                    volume_rkap: '657.823',
                    volume_rkap_ytd: '266.196',
                    volume_real_ytd_month: '312.565',
                    real_rkap_ytd: '117%',
                    real_rkap_month: '48%',
                    real_ytd_month: '113%',
                },
                {
                    product: 'Pertamax',
                    month_ytd: '275.897',
                    volume_rkap: '657.823',
                    volume_rkap_ytd: '266.196',
                    volume_real_ytd_month: '312.565',
                    real_rkap_ytd: '117%',
                    real_rkap_month: '48%',
                    real_ytd_month: '113%',
                },
                {
                    product: 'Pertamax Turbo',
                    month_ytd: '275.897',
                    volume_rkap: '657.823',
                    volume_rkap_ytd: '266.196',
                    volume_real_ytd_month: '312.565',
                    real_rkap_ytd: '117%',
                    real_rkap_month: '48%',
                    real_ytd_month: '113%',
                },
                {
                    product: 'Pertalite',
                    month_ytd: '275.897',
                    volume_rkap: '657.823',
                    volume_rkap_ytd: '266.196',
                    volume_real_ytd_month: '312.565',
                    real_rkap_ytd: '117%',
                    real_rkap_month: '48%',
                    real_ytd_month: '113%',
                },
                {
                    product: 'Pertalite (PLK)',
                    month_ytd: '275.897',
                    volume_rkap: '657.823',
                    volume_rkap_ytd: '266.196',
                    volume_real_ytd_month: '312.565',
                    real_rkap_ytd: '117%',
                    real_rkap_month: '48%',
                    real_ytd_month: '113%',
                },
                {
                    product: 'Total',
                    month_ytd: '275.897',
                    volume_rkap: '657.823',
                    volume_rkap_ytd: '266.196',
                    volume_real_ytd_month: '312.565',
                    real_rkap_ytd: '117%',
                    real_rkap_month: '48%',
                    real_ytd_month: '113%',
                },
                {
                    product: 'Vigas',
                    month_ytd: '275.897',
                    volume_rkap: '657.823',
                    volume_rkap_ytd: '266.196',
                    volume_real_ytd_month: '312.565',
                    real_rkap_ytd: '117%',
                    real_rkap_month: '48%',
                    real_ytd_month: '113%',
                },
                {
                    product: 'BBG (KLsp)',
                    month_ytd: '275.897',
                    volume_rkap: '657.823',
                    volume_rkap_ytd: '266.196',
                    volume_real_ytd_month: '312.565',
                    real_rkap_ytd: '117%',
                    real_rkap_month: '48%',
                    real_ytd_month: '113%',
                },
                {
                    product: 'Grand Total',
                    month_ytd: '275.897',
                    volume_rkap: '657.823',
                    volume_rkap_ytd: '266.196',
                    volume_real_ytd_month: '312.565',
                    real_rkap_ytd: '117%',
                    real_rkap_month: '48%',
                    real_ytd_month: '113%',
                },
            ]
        }
    },
    watch: {

	}, 
    mounted() {
        this.$emit('childrenRoute');
        this.setDefaultPeriod()
        this.resumePilihan()
    },
    methods: {
        resumePilihan() {
            this.urlRequestParams=Config().apiURL
			this.urlRequestParams+='/financial-performance/sales-volume?'
            
            this.urlRequestParams+='&year='+this.year
            this.urlRequestParams+='&month='+this.month

			this.loading.table = true;
            AxiosWithJar().get(this.urlRequestParams)
            .then((response)=>{ 
                this.reportData = response.data;
                this.lastUpdate = this.reportData.data.last_update
                //console.log('data: ' + JSON.stringify(this.reportData))
            })
			.catch(error => {
				console.log(error)
				//this.errored = true
				//error.response.data
			})
			.finally(() => {
				this.loading.table = false;
			})     

        },

        setDefaultPeriod() {
            // Mengecek apakah kunci 'username' sudah ada di localStorage
            if (localStorage.getItem('performanceDefaultMonth') !== null && localStorage.getItem('performanceDefaultYear') !== null) {
                //console.log('Period sudah ada di localStorage');
                let month = localStorage.getItem('performanceDefaultMonth')
                let year = localStorage.getItem('performanceDefaultYear')

                this.month = month
                this.year =  year
            } else {
                //console.log('period belum ada di localStorage');
            }
        },
        applyFilter() {
            this.resumePilihan()
        },
    },
}
</script>

<style scoped>
.app-table {
  font-family: Arial, Helvetica, sans-serif;
  border-collapse: collapse;
  width: 100%;
  border-radius:4px;
}

.app-table td, .app-table th {
  border: 2px solid #fff/*#ddd*/;
  padding: 4px 10px;
}

.app-table tr:nth-child(even){background-color: #e0f3ff/*#D9E1F2*//*#f2f2f2*/;}

.app-table tr:hover {background-color: rgba(66, 161, 255, 0.26) /*#ddd*/;}

.app-table th {
  padding-top: 6px;
  padding-bottom: 6px;
  text-align: center;
  background-color: #409EFF/*#0070C0*/;
  color: white;
}

.sub-header-cell {
    background-color: rgba(66, 161, 255, 0.46) /* #8EA9DB*/;
    font-weight:bold;
    color:#000;
}

.red-border {
    border-left:3px solid #F56C6C !important;
    border-right:3px solid #F56C6C !important;
}

.yellow-border {
    border-left:3px solid #E6A23C !important;
    border-right:3px solid #E6A23C !important;
}

.top-red-border {
    border-top:3px solid #F56C6C !important;
}
.bottom-red-border {
    border-bottom:3px solid #F56C6C !important;
}

.top-yellow-border {
    border-top:3px solid #E6A23C !important;
}

.bottom-yellow-border {
    border-bottom:3px solid #E6A23C !important;
}

</style>